import React from 'react';
import styles from './MatchPlanning.module.css';

/**
 * Kontrolki zamrożenia udziału w lidze (widok gracza). Wydzielone z MatchPlanning, żeby logikę
 * „co pokazać" dało się testować w izolacji.
 *
 * Stany:
 *  - frozenForNextRound → „Odmroź udział" (cofnięcie zgłoszonego zamrożenia),
 *  - freezesRemaining > 0 → aktywny „Zamroź (N)" / „Kontynuuj zamrożenie (N)" (gdy już zamrożony),
 *  - bez pozostałych zamrożeń (zamrożony lub aktywny) → NIEAKTYWNY „Kontynuuj zamrożenie"
 *    / „Zamróź" + info o limicie, żeby gracz rozumiał, czemu przycisk nie działa (wcześniej
 *    po prostu znikał),
 *  - zamrażanie wyłączone (maxFreezes=0) → nic (żaden komunikat o limicie nie ma sensu).
 */
export default function FreezeControls({
    isFrozen,
    frozenForNextRound,
    freezesRemaining,
    maxFreezes,
    onFreeze,
    onUnfreeze,
}) {
    const freezingEnabled = (maxFreezes ?? 0) > 0;
    const canFreeze = !frozenForNextRound && (freezesRemaining ?? 0) > 0;
    const limitReached = !frozenForNextRound && freezingEnabled && (freezesRemaining ?? 0) <= 0;

    if (!frozenForNextRound && !canFreeze && !limitReached) {
        return null;
    }

    return (
        <div className={styles.formButtons} style={{ marginBottom: 16 }}>
            {frozenForNextRound ? (
                <button className={styles.unfreezeButton} onClick={onUnfreeze}>
                    Odmroź udział
                </button>
            ) : canFreeze ? (
                <button className={styles.freezeButton} onClick={onFreeze}>
                    {isFrozen
                        ? `❄️ Kontynuuj zamrożenie (${freezesRemaining})`
                        : `❄️ Zamroź (${freezesRemaining})`}
                </button>
            ) : (
                <div className={styles.freezeLimitReached}>
                    <button className={styles.freezeButton} disabled>
                        {isFrozen ? '❄️ Kontynuuj zamrożenie' : '❄️ Zamroź'}
                    </button>
                    <span className={styles.freezeLimitNote}>
                        Wykorzystałeś limit zamrożeń{maxFreezes != null ? ` (${maxFreezes})` : ''}.
                    </span>
                </div>
            )}
        </div>
    );
}
